"use strict";
var ArrayObservable_1 = require('./ArrayObservable');
exports.of = ArrayObservable_1.ArrayObservable.of;
//# sourceMappingURL=of.js.map


//////////////////
// WEBPACK FOOTER
// P:/Projetos/PoloVeiculos/Fonte/PoloApp/SiteV3/polo-app/node_modules/rxjs/observable/of.js
// module id = ../../../../rxjs/observable/of.js
// module chunks = vendor